module.exports = __webpack_public_path__ + "96756f3a27dce622879e0952ee3160f5.txt";